import { useVersionCheck } from '@ferrodo-computer/version-control'
import InformationErrorModal from './Components/Modals/InformationErrorModal'
import { useAuth } from '../Providers/AuthProvider'

const VersionControl = () => {
    const { logout, isAutoLogoutBlocked } = useAuth()
    const { isUpdate, confirmUpdate } = useVersionCheck()

    const handleUpdate = async () => {
        await logout(true, true)
        confirmUpdate()
    }

    return (
        <InformationErrorModal
            show={isUpdate && !isAutoLogoutBlocked}
            setShow={handleUpdate}
            title={'Nowa wersja!'}
            message={'Uwaga wykryto nową wersję aplikacji, aby kontynuować niezbędne jest przeładowanie aplikacji!'}
            isError={false}
            isVersionControlInfo={true}
        />
    )
}

export default VersionControl
